export const BRIDGE_VERSION = '1.0.0';

export const BRIDGE_PROTOCOL = 'mastermind-bridge';
export const BRIDGE_PROTOCOL_VERSION = 1;

export const BRIDGE_METHODS = Object.freeze({
    CAPABILITIES: 'capabilities',
    BIOMETRIC_AUTHENTICATE: 'biometric.authenticate',
    NOTIFICATION_PERMISSION: 'notification.permission',
    NOTIFICATION_REQUEST: 'notification.request',
    NOTIFICATION_LOCAL: 'notification.local',
    SHARE: 'share',
    HAPTIC: 'haptic',
});

export const BRIDGE_ERROR = Object.freeze({
    UNAVAILABLE: 'UNAVAILABLE',
    PERMISSION_DENIED: 'PERMISSION_DENIED',
    CANCELLED: 'CANCELLED',
    TIMEOUT: 'TIMEOUT',
    INVALID_ARGUMENT: 'INVALID_ARGUMENT',
    INVALID_RESPONSE: 'INVALID_RESPONSE',
    NOT_ALLOWED: 'NOT_ALLOWED',
    NOT_ENROLLED: 'NOT_ENROLLED',
    LOCKED_OUT: 'LOCKED_OUT',
    DISPOSED: 'DISPOSED',
    FAILED: 'FAILED',
});

export const BRIDGE_ERROR_MESSAGE = Object.freeze({
    UNAVAILABLE: 'Esta capacidad no está disponible en este dispositivo.',
    PERMISSION_DENIED: 'El permiso fue denegado.',
    CANCELLED: 'La operación se canceló.',
    TIMEOUT: 'La operación tardó demasiado y se detuvo.',
    INVALID_ARGUMENT: 'Los datos enviados no son válidos.',
    INVALID_RESPONSE: 'El host respondió con datos no válidos.',
    NOT_ALLOWED: 'Esta operación no está permitida.',
    NOT_ENROLLED: 'No hay biometría configurada en el dispositivo.',
    LOCKED_OUT: 'La biometría está bloqueada por demasiados intentos.',
    DISPOSED: 'El puente se cerró antes de terminar.',
    FAILED: 'La operación falló.',
});

export const BRIDGE_TIMEOUT_MS = Object.freeze({
    DEFAULT: 10_000,
    BIOMETRIC: 60_000,
    SHARE: 120_000,
    PERMISSION: 60_000,
});

export const HAPTIC_STYLES = Object.freeze(['light', 'medium', 'heavy', 'success', 'warning', 'error']);
export const NOTIFICATION_STATES = Object.freeze(['granted', 'denied', 'prompt', 'unsupported']);
export const BIOMETRY_KINDS = Object.freeze(['face', 'fingerprint', 'iris', 'device', 'none']);
export const BRIDGE_PLATFORMS = Object.freeze(['web', 'android', 'ios', 'embedded']);
export const BRIDGE_HOSTS = Object.freeze(['browser', 'capacitor', 'iframe', 'webkit']);

export const BRIDGE_LIMITS = Object.freeze({
    SHARE_TITLE_MAX: 120,
    SHARE_TEXT_MAX: 500,
    URL_MAX: 2048,
    NOTIFICATION_TITLE_MAX: 80,
    NOTIFICATION_BODY_MAX: 240,
    BIOMETRIC_REASON_MAX: 120,
    MESSAGE_MAX: 200,
    SEEN_IDS_MAX: 500,
});

export const REQUEST_ID_PATTERN = /^[A-Za-z0-9-]{8,64}$/;

export const NATIVE_BIOMETRIC_PLUGIN = 'MastermindBiometric';
export const NATIVE_WEBKIT_HANDLER = 'mastermindBridge';
